export const newsItems = {
  CREATE_TRUE: "CREATE_TRUE",
  CREATE_FALSE: "CREATE_FALSE",
};
export const newCc = {
  CHANGE_CC: "CHANGE_CC",
};
export const NEW_ADDRES_VIEW = "NEW_ADDRES_VIEW";
